import React, { Component } from "react";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";


/*Projeto Junta Teste Maps*/
export default class Map extends Component {
  render() {
    return (
      <LoadScript
        id="script-loader"
        googleMapsApiKey="AIzaSyBBX6Tchi07r47lc6LRL6wPlCc1U35756U"
      >
        <GoogleMap
          id="circle-example"
          mapContainerStyle={{
            height: "400px",
            width: "100%"
          }}
          zoom={12}
          center={{
            lat: 40.40204,
            lng: -7.63966
          }}
        >
          <Marker
            position={{
              lat: 40.40204,
              lng: -7.63966
            }}
          />
        </GoogleMap>
      </LoadScript>
    );
  }
}
